"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const chat = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-chat" : '') + (description ? " desc-chat" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-chat"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-chat"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.9695 1C22.0909 1 23 1.90907 23 3.03047V16.8297C23 17.9511 22.0909 18.8602 20.9695 18.8602L11.5264 18.8601L6.18064 22.8699C5.77701 23.1726 5.21115 22.9194 5.14598 22.4416L5.13978 22.3495L5.139 18.8601L3.03047 18.8602C1.9558 18.8602 1.07612 18.0253 1.00468 16.9688L1 16.8297V3.03047C1 1.90907 1.90907 1 3.03047 1H20.9695ZM20.9695 2.30108H3.03047C2.62763 2.30108 2.30108 2.62763 2.30108 3.03047V16.8297C2.30108 17.2326 2.62763 17.5591 3.03047 17.5591H5.79032C6.1496 17.5591 6.44086 17.8504 6.44086 18.2097L6.44007 21.0477L10.9197 17.6892C11.0098 17.6217 11.1155 17.579 11.2262 17.5646L11.31 17.5591H20.9695C21.3724 17.5591 21.6989 17.2326 21.6989 16.8297V3.03047C21.6989 2.62763 21.3724 2.30108 20.9695 2.30108Z",
    fill: "inherit"
  }));
};
var _default = exports.default = chat;